module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-touch-keyboard"
  }, [_c('div', {
    staticClass: "keyboard"
  }, _vm._l((_vm.keySet), function(line, index) {
    return _c('div', {
      key: index,
      staticClass: "line"
    }, _vm._l((line), function(key, index) {
      return _c('span', {
        key: index,
        class: _vm.getClassesOfKey(key),
        style: (_vm.getKeyStyle(key)),
        domProps: {
          "innerHTML": _vm._s(_vm.getCaptionOfKey(key))
        },
        on: {
          "click": function (e) { return _vm.clickKey(e, key); },
          "mousedown": _vm.mousedown
        }
      })
    }), 0)
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e11bc78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e11bc78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard.vue
// module id = 527
// module chunks = 1